module.exports = __webpack_public_path__ + "static/media/Paus hörnsoffa 2 rekliner micro grå bistro miljö 2023 2.02ab2513.jpg";